import dayjs from "dayjs";

const moment = dayjs;

const dayMap = {
  0: "星期日",
  1: "星期一",
  2: "星期二",
  3: "星期三",
  4: "星期四",
  5: "星期五",
  6: "星期六"
};

const getMessageBoxTimeTip = (timestamp, preTimestamp) => {
  const currentDate = moment(timestamp),
    preDate = moment(preTimestamp),
    dateNow = moment();
  const diffMinuts = currentDate.diff(preDate, "minutes");
  let timeTip = "";
  // 两条消息间隔大于5分钟 需要展示时间
  if (diffMinuts >= 5) {
    const diffDays = moment(dateNow.format("YYYY-MM-DD")).diff(
      moment(currentDate.format("YYYY-MM-DD")),
      "days"
    );
    // 由于moment一周从周日开始 所以当天如果是周日 周一上移6天 否则下移一天
    const firstDayOfWeek =
      moment().day() === 0
        ? moment()
          .startOf("week")
          .add(-6, "day")
        : moment()
          .startOf("week")
          .add(1, "day");
    const endDayOfWeek =
      moment().day() === 0
        ? moment()
          .endOf("week")
          .add(-6, "day")
        : moment()
          .endOf("week")
          .add(1, "day");
    // 当天
    if (diffDays === 0) {
      timeTip = currentDate.format("HH:mm");
      //  昨天
    } else if (diffDays === 1) {
      timeTip = "[昨天] " + currentDate.format("HH:mm");
      // 一周内
      // tslint:disable-next-line:prefer-conditional-expression
    } else if (
      currentDate >= firstDayOfWeek &&
      currentDate <= endDayOfWeek
    ) {
      timeTip =
        dayMap[currentDate.day()] + " " + currentDate.format("HH:mm");
      // 大于一周
    } else {
      timeTip = currentDate.format("YYYY-MM-DD HH:mm");
    }
  }
  return timeTip;
};

export default getMessageBoxTimeTip;
